export default __webpack_public_path__ + "1b5986b357ab2388052f59a80144c2e3.png";